export default function(auth, commit) {
	if (auth.type === 'patient')
		commit('provider/updatePatient', { patient: auth })
}
